<template>
    <div
        :class="['edit-modal-mask', bModalEffectMask ? 'fade-in':'fade-out']"
        v-show="bModalMaskShow"
    >
        <transition name="collapse-list">
            <div class="edit-modal" v-show="bEditModalShow">
                <div class="edit-modal-header">
                    {{ title }}
                    <div class="close" @click="closeModal()"></div>
                </div>
                <div class="edit-modal-content">
                    <div class="edit-goods-list" v-if="arrChecked.length === 0 && !oGoodsInfo.bFloor">
                        <ul v-if="oGoodsInfo.arrWind && oGoodsInfo.arrWind.length !== 0">
                            <li v-for="(item, index) in oGoodsInfo.arrWind" :key="index">
                                <div class="img-box">
                                    <img :src="item.mobile_thumb" alt="">
                                </div>
                                <div class="goods-info">
                                    <div class="goods-name">{{ item.cate_name }} <span>{{ item.goods_name }}</span></div>
                                    <div class="goods-attr">
                                        <div>重要参数：</div>
                                        <div v-for="(attrItem, attrIndex) in item.attr_two" :key="attrIndex">{{attrItem.attr_name}}:{{attrItem.attr_value}}</div>
                                    </div>
                                </div>
                                <div class="count">x {{item.nNum}}</div>
                                <div class="yx"></div>
                            </li>
                        </ul>
                    </div>
                    <div class="edit-goods-list" v-if="arrChecked.length !== 0 || oGoodsInfo.bFloor">
                        <ul v-if="arrChecked.length !== 0">
                            <li v-for="(item, index) in arrChecked" :key="index">
                                <div class="img-box">
                                    <img :src="item.mobile_thumb" alt="">
                                </div>
                                <div class="goods-info">
                                    <div class="goods-name">{{ item.cate_name }} <span>{{ item.goods_name }}</span></div>
                                    <div class="goods-attr">
                                        <div>重要参数：</div>
                                        <div v-for="(attrItem, attrIndex) in item.attr_two" :key="attrIndex">{{attrItem.attr_name}}:{{attrItem.attr_value}}</div>
                                    </div>
                                </div>
                                <!-- <div class="count">x {{item.nNum}}</div> -->
                                <div class="edit-count" @click.stop="openPiker(index)">
                                    <p>{{item.nNum || '选择数量'}}</p>
                                </div>
                                <!-- <div class="yx"></div> -->
                                <div class="floor-icon">{{ item.floor | floorText }}</div>
                                <div class="delete" @click="deletedChange(index)"></div>
                            </li>
                        </ul>
                    </div>
                    <div class="edit-modal-top">
                        <div class="search">
                            <img src="@/assets/images/ant/search.png" alt="" @click="searchChange()">
                            <input type="text" name="" id="" v-model="sKeyWord" @change="searchChange" @blur.prevent="changeBlur()">
                        </div>
                        <div class="select" @click="$refs.calssPicker.show()" v-if="oGoodsInfo.goods_type_id === 201||oGoodsInfo.goods_type_id === 215||oGoodsInfo.goods_type_id === 216">
                            <div class="name">{{sClassValue[0].value}}</div>
                            <div class="select-icon"></div>
                        </div>
                    </div>
                    <div class="goods-list"
                        v-infinite-scroll="loadMore"
                        infinite-scroll-disabled="true"
                        infinite-scroll-distance="0"
                        infinite-scroll-immediate-check="true"
                    >
                        <!-- <pull-to
                            :distance-index="3"
                            :top-config="TOP_DEFAULT_CONFIG"
                            :bottom-config="BOTTOM_DEFAULT_CONFIG"
                            :top-load-method="downRefresh"
                            :bottom-load-method="upRefresh"
                            :is-bottom-bounce="true"
                            bottom-block-height:0
                            top-block-height:0
                        > -->
                            <div v-if="!isNotData">
                                <div class="goods-item" v-for="(item, index) in arrGoodsList" :key="item.id">
                                    <div class="img-box">
                                        <img v-lazy="item.mobile_thumb" alt="">
                                    </div>
                                    <div class="goods-info">
                                        <p class="goods-name">{{ item.cate_name }} <span>{{ item.goods_name }}</span></p>
                                        <div class="goods-attr">
                                            <div>重要参数：</div>
                                            <div v-for="(attrItem, attrIndex) in item.attr_two" :key="attrIndex">{{attrItem.attr_name}}:{{attrItem.attr_value}}</div>
                                        </div>
                                    </div>
                                    <div class="add-btn" @click.stop="selectChange(item, index)">添加</div>
                                    <!-- <div :class="['no-checked', item.checked ? 'checked':'']"></div> -->
                                </div>
                                <div class="dropload-tip" v-if="isToEnd">我是有底线的</div>
                            </div>
                            <div class="not-data" v-else>暂时还没有数据哦~</div>
                        <!-- </pull-to> -->
                    </div>
                </div>
                <div class="edit-btn">
                    <button class="confirm-btn" @click="closeSearchModal()">确定</button>
                </div>
            </div>
        </transition>

        <!-- 选择数量 -->
        <awesome-picker ref="picker" :anchor="sSelectValue" :data="arrSelectList" :colorConfirm="oPicker.colorConfirm" @confirm="confirmPicker"></awesome-picker>

        <!-- 选择暖气分类 -->
        <awesome-picker ref="calssPicker" :anchor="sClassValue" :data="arrClassList" :colorConfirm="oPicker.colorConfirm" @confirm="classConfirmPicker"></awesome-picker>

        <!-- 楼层选择弹窗 -->
        <div class="slelect-floor-mask" v-if="bShowfloorModal" @click.stop.prevent="bShowfloorModal = false">
            <div class="slelect-floor" @click.stop>
                <div class="slelect-floor-head">请选择设备归属楼层</div>
                <div class="slelect-floor-content">
                    <ul>
                        <li :class="[nActiveFloorIndex === index ? 'active':'']" v-for="(item, index) in oGoodsInfo.arrFloor" :key="index" @click="selectTags(index)">{{ oFloor[item.room] }}</li>
                    </ul>
                </div>
                <div class="btn-wrap">
                    <button @click="closeFloorConfirm()">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PullTo from 'vue-pull-to';
import { getGoodsList } from '@/js/map.js'
export default {
    name: 'multipleModal',
    components:{
        PullTo
    },
    data() {
        return {
            bModalEffectMask:false, // 动画开关
            bModalMaskShow:false, // mask开关

            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },
            BOTTOM_DEFAULT_CONFIG: {
                pullText: '上拉加载',
                triggerText: '释放更新',
                loadingText: '加载中...',
                doneText: '加载完成',
                failText: '加载失败',
                loadedStayTime: 400,
                stayDistance: 50,
                triggerDistance: 70
            },

            nPage: 0, //页数
            sKeyWord: '', //搜索关键词
            arrGoodsList:[], // 产品列表
            isToEnd:false, // 是否到底
            isNotData:true, // 是否有数据

            arrChecked:[],

            oPicker: {
                colorConfirm: "rgba(33, 51, 102, 1)"
            },

            arrSelectList:[],
            sSelectValue:[{value:1 }],
            nActive:null,

            oFloor: {
                '1': '一层',
                '2': '二层',
                '3': '三层',
                '4': '四层',
                '-1': '地下室一层',
                '-2': '地下室二层',
            },

            nActiveFloorIndex: null,
            bShowfloorModal: false,
            nAddIndex: null,

            scrollTop:null, //记住页面滚动位置

            // 选择风盘才出现的下拉列表
            arrClassList:[
                { value:'风盘', id:201 },
                { value:'散热片', id:215 },
                { value:'地暖管', id:216 },
            ],
            sClassValue:[{ value:'风盘', id:201 }],
            bGoodsBo:true,
        }
    },
    props: {
        title:{
            type: String,
            default: '设备选型'
        },
        // 信息
        oGoodsInfo: {
            type: Object,
            default: () => { return {
                    arrWind: [],
                    goods_type_id: 0,
                    energy_cold: 0
                }
            }
        },
        bEditModalShow: {
            type: Boolean,
            default: false
        },
    },
    filters:{
        floorText(value) {
            let key = value || 0
            const oFloor = {
                '0': '已选',
                '1': '一层',
                '2': '二层',
                '3': '三层',
                '4': '四层',
                '-1': '地下室一层',
                '-2': '地下室二层',
            }
            return oFloor[key]
        }
    },
    created() {
        for (let i = 1; i <= 50; i++) {
            this.arrSelectList.push({
                value: i
            })
        }
    },
    mounted(){

    },
    computed:{

    },
    watch:{
        bEditModalShow:{
            handler (newValue, oldValue ) {
                if (newValue) {
                    this.bShowfloorModal = false
                    this.nActiveFloorIndex = null
                    this.arrChecked = []
                    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                    document.body.classList.add("dialog");
                    this.bModalMaskShow = newValue
                    this.bModalEffectMask = newValue
                    this.nPage = 0;
                    this.arrGoodsList = [];
                    this.getGoodsList()
                } else {
                    document.body.classList.remove("dialog");
                    window.scrollTo(0, this.scrollTop);
                    this.nPage = 0
                    this.sKeyWord = ''
                    this.arrGoodsList = []
                    this.bModalEffectMask = newValue
                    setTimeout(() => {
                        this.bModalMaskShow = newValue
                    }, 500)
                }
            },
            immediate: true,
        }
    },
    methods:{
        // 楼层弹窗选中标签
        selectTags (index) {
            this.nActiveFloorIndex = index
        },
        //选择楼层确认
        closeFloorConfirm () {
            const { arrFloor } = this.oGoodsInfo
            if (this.nActiveFloorIndex === null) {
                this.$toast('请选择楼层！')
                return false
            }

            // 产品id和楼层同时存在
            const active = this.arrChecked.findIndex(_ => _.id === this.arrGoodsList[this.nAddIndex].id && _.floor === arrFloor[this.nActiveFloorIndex].room)

            if (~active) {
                // 已存在
                this.arrChecked[active].nNum++
            } else {
                // 不存在
                let goods = JSON.parse(JSON.stringify(this.arrGoodsList[this.nAddIndex]))
                goods.floor = arrFloor[this.nActiveFloorIndex].room
                goods.nNum = 1
                this.arrChecked.unshift(goods)
            }

            this.bShowfloorModal = false
        },
        deletedChange(index) {
            this.arrChecked.splice(index, 1)
        },
        // 点击放大镜
        searchChange() {
            this.nPage = 0
            this.arrGoodsList = []
            this.getGoodsList()
        },
        active(item) {
            const index = this.arrChecked.findIndex(_ => _.id === item.id)
            return ~index ? true : false
        },
        // 选择产品
        selectChange(item, index) {
         //   console.log(this.arrChecked,item)
            if (this.oGoodsInfo.goods_type_id === 201 && item.new_goods_type_id === 215 &&　~this.arrChecked.findIndex(_ => _.new_goods_type_id === 216)) {
                this.$toast('您已经选择了，请勿重复！')
                return false
            }
            if (this.oGoodsInfo.goods_type_id === 201 && item.new_goods_type_id === 216 &&  ~this.arrChecked.findIndex(_ => _.new_goods_type_id === 215)) {
                this.$toast('您已经选择了散热片，请勿重复！')
                return false
            }
            const active = this.arrChecked.findIndex(_ => _.id === item.id)
            if (!~active) {
                // 不存在
                if (this.oGoodsInfo.bFloor) {
                    // 选型修改
                    if (this.oGoodsInfo.arrFloor.length === 1 && this.oGoodsInfo.arrFloor[0].room === 1) {
                        //只有一层，不用选择楼层
                        item.nNum = 1
                        item.floor = 1
                        this.arrChecked.unshift(item)
                    } else {
                        // if(this.oGoodsInfo.goods_type_id==200){
                            item.nNum = 1
                            item.floor = this.oGoodsInfo.nFloor;
                            this.arrChecked.unshift(item)
                        // }else{
                            // 多层，开启选楼层弹窗
                        //     this.nActiveFloorIndex = null
                        //     this.bShowfloorModal = true
                        //     this.nAddIndex = index
                        // }
                    }
                } else {
                    // 修改风盘
                    item.nNum = 1
                    this.arrChecked.unshift(item)
                }
            } else {
                // 已存在
                if (this.oGoodsInfo.bFloor) {
                    // 选型修改
                    if (this.oGoodsInfo.arrFloor.length === 1 && this.oGoodsInfo.arrFloor[0].room === 1) {
                        //只有一层，不用选择楼层
                        this.arrChecked[active].nNum++
                    } else {
                        // if(this.oGoodsInfo.goods_type_id==200){
                            item.nNum = 1
                            item.floor = this.oGoodsInfo.nFloor
                            this.arrChecked.unshift(item)
                        // }else{
                            // 多层，开启选楼层弹窗
                        //     this.nActiveFloorIndex = null
                        //     this.bShowfloorModal = true
                        //     this.nAddIndex = index
                        // }
                    }
                } else {
                    // 修改风盘
                    this.arrChecked[active].nNum++
                }
            }
        },
        openPiker(index) {
            this.nActive = index
            this.$refs.picker.show();
        },

        confirmPicker(res) {
            this.arrChecked[this.nActive].nNum = res[0].value
           // console.log(this.arrGoodsList[this.nActive])
        },
        // 选择分类
        classConfirmPicker (res) {
            this.nPage = 0
            this.arrGoodsList = []
            this.sClassValue = [this.arrClassList[res[0].index]]
            this.getGoodsList()
        },
        // 确定
        closeSearchModal() {
            if (this.arrChecked.length === 0) {
                this.$toast('您还没有选择产品！')
                return false
            }
            const { bFloor } = this.oGoodsInfo
            // 有楼层代表选型、没楼层代表选风盘
            if (bFloor) {
                const { system_id, goods_type_id, arrFloor } = this.oGoodsInfo
                let checkrData = {
                    system_id: system_id,
                    data: this.arrChecked,
                    goods_type_id: goods_type_id
                }
                let oTips = {
                    fail: 0,
                    text: ''
                }
                let power = 0
                if (system_id === 1) {
                    if (goods_type_id === 200) { // 变频户式空气源热泵机组
                        this.arrChecked.forEach(item => {
                            power += Number(item.power) * item.nNum
                        })
                        oTips.fail = power > this.oGoodsInfo.power ? 0 : 1
                        oTips.text = power > this.oGoodsInfo.power ? '' : '您选择产品的采暖系统功率不足'
                    } else { // 其他
                        oTips.fail = 0
                        oTips.text = ''
                    }
                }
                else if (system_id === 2) { //热水系统（包括四种壁挂炉）
                    this.arrChecked.forEach(item => {
                        power += Number(item.power) * 1000 * item.nNum
                    })
                    oTips.fail = power > this.oGoodsInfo.water_energy ? 0 : 1
                    oTips.text = power > this.oGoodsInfo.water_energy ? '' : '您选择产品的热水系统功率不足'
                }
                else if (system_id === 3) { // 中央新风
                    this.arrChecked.forEach(item => {
                        power += Number(item.wind) * item.nNum
                    })
                    oTips.fail = power > this.oGoodsInfo.wind_energy ? 0 : 1
                    oTips.text = power > this.oGoodsInfo.wind_energy ? '' : '您选择产品的中央新风系统风量不足'
                }
                else if (system_id === 4) {
                    switch (goods_type_id) {
                        case 207:  // 前置过滤器
                            this.arrChecked.forEach(item => {
                                power += Number(item.power) * item.nNum
                            })
                            oTips.fail = power > this.oGoodsInfo.water_clean ? 0 : 1
                            oTips.text = power > this.oGoodsInfo.water_clean ? '' : '您选择产品的前置过滤器水流量不足'
                            break;
                        case 209: // 中央净水
                            this.arrChecked.forEach(item => {
                                power += Number(item.power) * item.nNum
                            })
                            oTips.fail = power > this.oGoodsInfo.water_clean ? 0 : 1
                            oTips.text = power > this.oGoodsInfo.water_clean ? '' : '您选择产品的净水机水流量不足'
                            break;
                        case 210: // 软水
                            this.arrChecked.forEach(item => {
                                power += Number(item.power) * item.nNum
                            })
                            oTips.fail = power > this.oGoodsInfo.water_soft ? 0 : 1
                            oTips.text = power > this.oGoodsInfo.water_soft ? '' : '您选择产品的软水机水流量不足'
                            break;
                    }
                } else { // 其他
                    oTips.fail = 0
                    oTips.text = ''
                }
              //  console.log('---->', power, this.oGoodsInfo, checkrData)
                if (oTips.fail) {
                    this.$toast(oTips.text)
                    // return false
                }
                this.$emit('confirm', checkrData)
                this.closeModal()
            } else {
                let power = 0
                this.arrChecked.forEach(item => {
                    power += item.power * item.nNum
                })
                if (power < this.oGoodsInfo.energy_cold) {
                    this.$toast({
                        message: "您选择产品功率过小",
                        duration: 1500,
                    });
                    // return false
                }
                this.closeModal()
                this.$emit('confirm', { data: this.arrChecked, oFloor:{} })
            }
        },
        closeModal() {
            this.$emit('update:bEditModalShow', false)
        },
        //下拉
        downRefresh(loaded) {
            this.arrGoodsList = []
            this.nPage = 0
            this.getGoodsList(() => {
                loaded('done')
            })
        },
        // 上拉加载
        upRefresh(loaded) {
            if (!this.isToEnd) {
                this.nPage++
                this.getGoodsList(() => {
                    loaded('done')
                })
            } else {
                loaded('done')
            }
        },
        loadMore(){
            this.nPage++
            this.getGoodsList();
        },
        // 获取产品列表
        async getGoodsList(callback) {
            this.$store.commit("loadSwitch", true)
            let system_id = this.oGoodsInfo.system_id === 2 ? this.oGoodsInfo.system_id : 0
            let type_id = this.oGoodsInfo.system_id === 2 ?　0 : this.oGoodsInfo.goods_type_id || 0

            // 如果是修改风盘就传下拉选择的值
            if (this.oGoodsInfo.goods_type_id === 201||this.oGoodsInfo.goods_type_id === 215||this.oGoodsInfo.goods_type_id === 216) {
                type_id = this.sClassValue[0].id
            }
            const resuqestData = {
                plan: 0,
                system_id: system_id,
                word: this.sKeyWord,
                type_id: type_id,
                page: this.nPage,
                limit: 10
            }
            const resultData = await getGoodsList(resuqestData)
            resultData.data.data.result.list.forEach(item => {
                item.nNum = 1
                item.attr_one = [] // 右边重要卖点
                item.attr_two = [] // 下面参数
                item.attr.forEach(it => {
                    it.attr_name = it.attr_name.replace(/[\r\n]/g,"").replace(/\ +/g,"") // 过滤空格、换行
                    it.attr_value = it.attr_value ? it.attr_value.replace(/[\r\n]/g,"").replace(/\ +/g,"") : '' // 过滤空格、换行
                    if (it.attr_mean == 1 || it.attr_mean == 2 || it.attr_mean == 3) {  // 右边重要卖点分离
                        item.attr_one.push(it)
                    }
                    if (it.attr_mean == 4 || it.attr_mean == 5 || it.attr_mean == 6) { // 下面参数分离
                        item.attr_two.push(it)
                    }
                })
            })
            if (resultData.data.data.result.list.length === 0) {
                this.isToEnd = true
            } else {
                this.isToEnd = false
                this.arrGoodsList = [...this.arrGoodsList, ...resultData.data.data.result.list]
            }
            this.$store.commit("loadSwitch", false)
            this.isNotData = this.arrGoodsList.length === 0 ? true : false
            callback && callback()
        },
        // 修复键盘弹起bug
        changeBlur(){
            let u = navigator.userAgent, app = navigator.appVersion;
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if(isIOS){
                setTimeout(() => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
                window.scrollTo(0, Math.max(scrollHeight - 1, 0))
                }, 200)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .slelect-floor-mask{
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        background-color: rgba(0,0,0,0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        .slelect-floor{
            width: 660px;
            min-height: 485px;
            border-radius: 20px;
            background-color: #fff;
            padding: 30px;
            .slelect-floor-head{
                font-size: 34px;
                color: rgb(45, 45, 45);
                font-weight: bold;
            }
            .slelect-floor-content{
                margin-top: 30px;
                ul{
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    li{
                        background-color: rgb(247, 247, 253);
                        border-radius: 55px;
                        font-size: 30px;
                        color: rgb(45, 45, 45);
                        text-align: center;
                        height: 70px;
                        line-height: 72px;
                        margin-right: 15px;
                        width: 30%;
                        margin-bottom: 30px;
                    }
                    li:last-child{
                        margin-right: 0;
                    }
                    .active{
                        border-width: 2px;
                        border-color: rgb(44, 122, 236);
                        border-style: solid;
                        color: rgb(44, 122, 236);
                    }
                }
            }
            .btn-wrap{
                margin-top: 50px;
                display: flex;
                justify-content: center;
                button{
                    width: 290px;
                    height: 80px;
                    background-color: #2f7fed;
                    border-radius: 40px;
                    font-size: 32px;
                    color: #fff;
                }
            }
        }
    }
    .edit-modal-mask{
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 888;
        background-color: rgba(0,0,0,0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        .edit-modal{
            width: 660px;
            border-radius: 20px;
            background-color: #f5f8ff;
            overflow: hidden;
            // padding: 50px 30px;
            .edit-modal-header{
                background-color: rgb(47, 127, 237);
                height: 67px;
                line-height: 67px;
                text-align: center;
                font-size: 26px;
                color: rgb(255, 255, 255);
                position: relative;
                .close{
                    position: absolute;
                    top: 10px;
                    right: 20px;
                    background: url("~@/assets/images/ant/icon_del.png") top/100% auto no-repeat;
                    width: 40px;
                    height: 40px;
                }
            }
            .edit-modal-content{
                padding: 0 30px;
                .edit-goods-list{
                    overflow-x: scroll;
                    overflow-y: hidden;
                    // padding: 10px 0;
                    ul{
                        margin-top: 30px;
                        display: flex;
                        li{
                            flex-shrink: 0;
                            border: 1Px solid #dce2fc;
                            border-radius: 10px;
                            background-color: rgb(255, 255, 255);
                            width: 555px;
                            height: 214px;
                            padding: 30px 20px;
                            margin-right: 15px;
                            display: flex;
                            align-items: center;
                            border-bottom: 1Px solid #bebebe;
                            position: relative;
                            .img-box{
                                width: 139px;
                                height: 169px;
                                display: flex;
                                align-items: center;
                                margin-right: 15px;
                                overflow: hidden;
                            }
                            img{
                                width: 139px;
                                // height: 169px;
                                flex-shrink: 0;
                            }
                            .goods-info{

                                .goods-name{
                                    font-size: 24px;
                                    color: rgb(45, 45, 45);
                                    font-weight: bold;
                                    span{
                                        font-weight: normal;
                                        font-size: 20px;
                                        color: rgba(67, 67, 67, 0.8);
                                    }
                                }
                                .goods-attr{
                                    // margin-top: 10px;
                                    div {
                                        font-size: 20px;
                                        color: rgba(67, 67, 67, 0.8);
                                    }
                                }
                            }
                            .edit-count{
                                border: 1Px solid #dce2fc;
                                background-color: rgb(245, 248, 255);
                                position: absolute;
                                right: 15px;
                                bottom: 15px;
                                width: 125px;
                                height: 38px;
                                border-radius: 35px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                p{
                                    text-align: center;
                                    width: 80px;
                                    font-size: 20px;
                                    color: rgb(47, 127, 237);
                                }
                                &::after{
                                    margin-left: 5px;
                                    content: '';
                                    display: inline-block;
                                    background: url("~@/assets/images/ant/angle1.png") top/100% auto no-repeat;
                                    width: 11px;
                                    height: 10px;
                                }
                            }
                            .count{
                                color: rgb(47, 127, 237);
                                font-size: 28px;
                                position: absolute;
                                right: 30px;
                                bottom: 30px;
                            }
                            .yx{
                                position: absolute;
                                top: 0;
                                left: 0;
                                background: url("~@/assets/images/ant/yx.png") top/100% auto no-repeat;
                                background-position: -7px -12px;
                                // width: 90px;
                                // height: 38px;
                                width: 107px;
                                height: 51px;
                            }
                            .floor-icon{
                                position: absolute;
                                top: 0;
                                left: 0;
                                background-color: #e5eeff;
                                color: rgb(47, 127, 237);
                                border-bottom-right-radius: 30px;
                                padding: 10px 30px 10px 23px;
                            }
                            .delete{
                                position: absolute;
                                top: 5px;
                                right: 6px;
                                background: url("~@/assets/images/ant/form/icon_del2.png") top/100% auto no-repeat;
                                // background-position: 10px -9px;
                                // width: 90px;
                                // height: 38px;
                                width: 35px;
                                height: 35px;

                            }
                        }
                    }
                }
                .edit-modal-top{
                    margin-top: 30px;
                    display: flex;
                    align-items: center;
                    .search{
                        // margin: 30px 0;
                        border-width: 2px;
                        border-color: rgb(47, 127, 237);
                        border-style: solid;
                        width: 100%;
                        height: 63px;
                        border-radius: 30px;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        img{
                            width: 34px;
                            height: 34px;
                            flex-shrink: 0;
                            margin-right: 20px;
                        }
                        input{
                            width: 100%;
                            font-size: 26px;
                            color: rgb(45, 45, 45);
                            background: transparent;
                        }
                    }
                    .select{
                        margin-left: 15px;
                        border-width: 2px;
                        border-color: rgb(47, 127, 237);
                        border-style: solid;
                        width: 250px;
                        height: 63px;
                        border-radius: 30px;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .select-icon{
                            // margin-top: 5px;
                            margin-left: 10px;
                            width: 18px;
                            height: 16px;
                            flex-shrink: 0;
                            background: url("~@/assets/images/ant/map/arrow_blue.png") top/100% auto no-repeat;
                        }
                        .name{
                            width: 120px;
                            height: 32px;
                            overflow: hidden;
                        }
                    }
                }
                .tag{
                    // margin-top: 40px;
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        li{
                            padding: 14px;
                            border: 1Px solid #dce2fc;
                            border-radius: 10px;
                            background-color: rgb(255, 255, 255);
                            font-size: 24px;
                            color: rgb(47, 127, 237);
                            margin-bottom: 15px;
                            span{
                                font-size: 22px;
                                color: rgb(67, 67, 67);
                            }
                        }
                    }
                }
                .goods-list{
                    margin-top: 30px;
                    border: 1Px solid #dce2fc;
                    border-radius: 10px;
                    background-color: rgb(255, 255, 255);
                    height: 522px;
                    padding: 30px 20px;
                    overflow: auto;
                    .goods-item{
                        padding: 10px;
                        display: flex;
                        align-items: center;
                        border-bottom: 1Px solid #bebebe;
                        position: relative;
                        .img-box{
                            width: 139px;
                            height: 169px;
                            display: flex;
                            align-items: center;
                            margin-right: 15px;
                            overflow: hidden;
                        }
                        img{
                            width: 139px;
                            // height: 169px;
                            flex-shrink: 0;
                        }
                        .goods-info{
                            p{
                                font-size: 24px;
                                color: rgb(45, 45, 45);
                                font-weight: bold;
                                span{
                                    font-weight: normal;
                                    font-size: 20px;
                                    color: rgba(67, 67, 67, 0.8);
                                }
                            }
                            .goods-attr{
                                // margin-top: 10px;
                                div {
                                    font-size: 20px;
                                    color: rgba(67, 67, 67, 0.8);
                                }
                            }
                        }
                        .add-btn{
                            position: absolute;
                            right: 15px;
                            top: 60px;
                            width: 100px;
                            height: 45px;
                            border: 2px solid #2f7fed;
                            // background-color: #fff;
                            border-radius: 40px;
                            font-size: 28px;
                            color: #2f7fed;
                            text-align: center;
                            line-height: 45px;
                        }
                        .no-checked{
                            position: absolute;
                            top: 10px;
                            left: 0px;
                            background: url("~@/assets/images/ant/no_checked.png") top/100% auto no-repeat;
                            width: 30px;
                            height: 30px;
                        }
                        .checked{
                            position: absolute;
                            top: 10px;
                            left: 0px;
                            background: url("~@/assets/images/ant/checked.png") top/100% auto no-repeat;
                            width: 30px;
                            height: 30px;
                        }
                        .edit-count{
                            border: 1Px solid #dce2fc;
                            background-color: rgb(245, 248, 255);
                            position: absolute;
                            right: 15px;
                            top: 53px;
                            width: 125px;
                            height: 38px;
                            border-radius: 35px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            p{
                                text-align: center;
                                width: 80px;
                                font-size: 20px;
                                color: rgb(47, 127, 237);
                            }
                            &::after{
                                margin-left: 5px;
                                content: '';
                                display: inline-block;
                                background: url("~@/assets/images/ant/angle1.png") top/100% auto no-repeat;
                                width: 11px;
                                height: 10px;
                            }
                        }
                    }
                }
            }
            .edit-btn{
                margin-top: 30px;
                margin-bottom: 30px;
                display: flex;
                justify-content: center;
                .confirm-btn{
                    width: 290px;
                    height: 80px;
                    background-color: #2f7fed;
                    border-radius: 40px;
                    font-size: 32px;
                    color: #fff;
                }
            }
        }
    }
    .collapse-enter-active {
        transition: all .8s ease;
    }
    .collapse-leave-active {
        transition: all .8s ease;
    }
    .collapse-enter, .collapse-leave-to {
        transform: translateY(540px);
    }

    .collapse-list-enter-active {
        transition: all .5s ease;
    }
    .collapse-list-leave-active {
        transition: all .5s ease;
    }
    .collapse-list-enter, .collapse-list-leave-to {
        transform: translateY(-540px);
    }

    .dropload-tip {
        text-align: center;
        font-size: 24px;
        padding: 10px 0;
        background-color: #fff;
        margin-top: 20px;
    }
    .not-data{
        text-align: center;
        font-size: 24px;
        height: 100%;
    }

    .fade-in {
        animation: fadeIn .5s ease forwards;
    }
    .fade-out {
        animation: fadeOut .5s ease forwards;
    }
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
    @keyframes fadeOut {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>
